// Export milestone hooks
export {
  useBrandMilestone,
  useBrandMilestoneByDate,
  useBrandRecordMilestoneOnce,
} from "./milestones/useBrandMilestone";
export {
  useRetailerMilestone,
  useRetailerMilestoneByDate,
  useRetailerRecordMilestoneOnce,
} from "./milestones/useRetailerMilestone";

// Export base milestone hooks for developers who want to use them directly
export {
  useMilestone,
  useMilestoneByDate,
  useMilestonesData,
} from "./milestones/useMilestoneBase";
export type { MilestoneState } from "./milestones/useMilestoneBase";
